import _classCallCheck from "@babel/runtime-corejs2/helpers/classCallCheck";
import _createClass from "@babel/runtime-corejs2/helpers/createClass";

var Attachments = /*#__PURE__*/function () {
  function Attachments(context) {
    _classCallCheck(this, Attachments);

    this.context = context;
  }

  _createClass(Attachments, [{
    key: "get",
    value: function get(entityType, entityId) {
      var sendNoCacheHeader = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
      var headers = sendNoCacheHeader ? {
        headers: {
          'cache-control': 'no-cache'
        }
      } : {};
      return this.context.http.get("/msvc/v1/attachments/items/".concat(entityType, "/").concat(entityId), null, headers);
    }
  }, {
    key: "post",
    value: function post(_ref) {
      var entityType = _ref.entityType,
          entityId = _ref.entityId,
          attachments = _ref.attachments;
      return this.context.http.post("/msvc/v1/attachments/item/".concat(entityType, "/").concat(entityId), attachments);
    }
  }, {
    key: "getTypes",
    value: function getTypes() {
      return this.context.http.get('/msvc/v1/attachments/metadata');
    }
  }]);

  return Attachments;
}();

export default Attachments;